module.exports = __webpack_public_path__ + "img/mastercard.f1a9d1d8.svg";